import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import StepTracker from '@tds/core-step-tracker';
import DimpleDivider from '@tds/core-dimple-divider';

import {
  keySecureBusiness,
  keySecureBusinessFr,
  QuoteSummaryFr,
  QuoteSummaryEn
} from '../utils/constant';
import { localeFr } from '../misc';

const ProgressBar = ({ name, steps, currentStep, locale, formName }) => {
  let progressSteps;

  if (
    locale === localeFr &&
    [keySecureBusiness, QuoteSummaryFr, QuoteSummaryEn].includes(name)
  ) {
    progressSteps = steps.map(item => _.get(item, 'fields.name', ''));
    const findIdx = progressSteps.indexOf(keySecureBusiness);
    progressSteps[findIdx] = keySecureBusinessFr;
  } else {
    progressSteps = steps.map(item => _.get(item, 'fields.name', ''));
  }
  return (
    <div>
      <div className="container 85%">
        <div id="title">
          <div id="title-wrapper">
            <div style={{ paddingTop: '2em' }}>
              <h2>
                <div id="title-label">{formName === 'Fully_Managed_Form'?'Proposal':name}</div>
              </h2>
              <div id="title-anchors" style={{ marginTop: '10px' }} />
            </div>
          </div>
        </div>
        {steps && steps.length > 1 && (
          <StepTracker
            copy="en"
            current={currentStep - 1}
            steps={progressSteps}
          />
        )}
        <DimpleDivider />
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  name: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  locale: PropTypes.string.isRequired
};

ProgressBar.defaultProps = {
  currentStep: 0
};

export default ProgressBar;
